import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const { RangePicker } = DatePicker;
/**
 * * 검색용 기간 셀렉트
 */

interface IProps {
  onChange: (date: any, dateString: any) => void;
  format: string;
  value: any;
  defaultValue?: any;
  defaultPickerValue?: any;
  showTime: boolean;
}
const SearchDatePicker: React.FC<IProps> = ({
  onChange,
  format,
  value,
  defaultValue,
  defaultPickerValue,
  showTime,
}) => {
  const { t } = useTranslation();
  const today: string = dayjs().format('YYYY-MM-DD HH:mm:00');

  return (
    <RangePicker
      // allowClear={true}
      showTime={showTime}
      format={format}
      onChange={onChange}
      defaultPickerValue={defaultPickerValue}
      defaultValue={defaultValue}
      value={value}
      ranges={{
        [t('searchDatePicker.today')]: [dayjs(), dayjs()],
        [t('searchDatePicker.thisWeek')]: [
          dayjs()?.startOf(today as any),
          dayjs().endOf('week'),
        ],
        [t('searchDatePicker.thisMonth')]: [
          dayjs()?.startOf(today as any),
          dayjs().endOf('month'),
        ],
      }}
    />
  );
};

export default SearchDatePicker;
